import { render, staticRenderFns } from "./threePartySDKTypeManagement.vue?vue&type=template&id=16c00348&scoped=true&"
import script from "./threePartySDKTypeManagement.vue?vue&type=script&lang=js&"
export * from "./threePartySDKTypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c00348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c00348')) {
      api.createRecord('16c00348', component.options)
    } else {
      api.reload('16c00348', component.options)
    }
    module.hot.accept("./threePartySDKTypeManagement.vue?vue&type=template&id=16c00348&scoped=true&", function () {
      api.rerender('16c00348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/threePartySDKTypeManagement.vue"
export default component.exports